/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCurrencyItemDto } from '../../models/backend-currency-item-dto';

export interface ListCurrenciesCurrenciesGet$Params {}

export function listCurrenciesCurrenciesGet(
  http: HttpClient,
  rootUrl: string,
  params?: ListCurrenciesCurrenciesGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCurrencyItemDto>>> {
  const rb = new RequestBuilder(rootUrl, listCurrenciesCurrenciesGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCurrencyItemDto>>;
    }),
  );
}

listCurrenciesCurrenciesGet.PATH = '/currencies';
